<template>
    <div class="pendencyBody">
        <CustomLoader v-if="isLoading" :width="70" />

        <b-card class="mainCardBG">
            <b-row>
                <b-navbar-nav>
                    <b-button @click="goBack" size="xxl" variant="light">
                        <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
                    </b-button>
                </b-navbar-nav>

                <b-col md="8">
                    <h5 class="page-title mb-2">
                        <b>{{ $route.name }}</b>
                    </h5>
                </b-col>
            </b-row>

            <div class="mt-3">
                <!-- Search Form Input -->
                <b-row>
                    <b-col md="8" class="my-1">
                        <b-form-group>
                            <b-input-group>
                                <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="filter"
                                    placeholder="Type to Search Assignment" ref="search" />
                                <b-input-group-append class="mr-1">
                                    <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>

                            <b-col md="3">
                                <label><b> Created User Filter</b></label>
                                <model-list-select :list="$store.getters['common/getAllUserList']" id="addedUserFilter"
                                    @input="debounceSearch" v-model="Filter.userFilter" option-value="userId"
                                    option-text="employeeName" placeholder="Select Created User" />
                            </b-col>
                        </b-form-group>
                    </b-col>

                    <b-col md="2">

                    </b-col>

                    <b-col md="2">
                        <h5>
                            <small v-if="!isLoading">{{ JOBList.length }} Entries</small>
                        </h5>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12" class="my-1">
                        <b-button class="pull-right mb-1" v-if="JOBList.length > 0"
                            :disabled="ExcelBtnName !== 'Export As Excel'"
                            @click="getReports('checkJobPendency', 'Export As Excel')" size="sm" variant="warning"
                            style="font-size: 0.675rem">
                            {{ ExcelBtnName }}
                            <b-spinner v-if="ExcelBtnName !== 'Export As Excel'" small
                                label="Small Spinner"></b-spinner>
                        </b-button>
                        <b-pagination limit="5" :total-rows="JOBList.length" :per-page="paginationItem.perPage"
                            v-model="paginationItem.currentPage" class="my-0 pull-right" />
                    </b-col>
                </b-row>

                <!-- Table Section -->
                <div class="col-md-12 row table-wrapper-scroll-x my-custom-scrollbar">
                    <b-table show-empty stacked="md" responsive :fields="columnMain" :items="JOBList"
                        class="table-background position-relative" :per-page="paginationItem.perPage"
                        :current-page="paginationItem.currentPage" :filter="filter" @filtered="onFiltered">
                        <template slot="SN" slot-scope="row0">
                            <span>
                                {{ row0.index + 1 }}
                            </span>
                            <b-button size="sm" style="margin-left: auto; font-size: 0.675rem" class="ml-1"
                                variant="outline-danger" @click="openModal(row0.item, 2)">
                                Update
                            </b-button>
                            <b-button v-if="row0.item.preq_client_log.length > 0" size="sm"
                                style="margin-left: auto; font-size: 0.675rem" class="ml-1" variant="outline-danger"
                                @click="openModal(row0.item, 1)">
                                Show Log
                            </b-button>
                        </template>

                    </b-table>
                </div>
            </div>

            <b-modal ref="UpdateCBModal" no-close-on-esc no-close-on-backdrop
                :title="'Update Information : ' + updateItem.JobNo" size="lg" hide-footer @hidden="closeModal">
                <!-- Modal content remains the same -->
                <b-row class="mb-2" v-if="modalType == 1">
                    <b-col cols="12">
                        <b-table show-empty stacked="md" responsive :fields="columnLogMain" :items="LogList"
                            class="table-background position-relative">
                            <template slot="SN" slot-scope="row0">
                                <span>
                                    {{ row0.index + 1 }}
                                </span>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
                <b-row class="mb-2" v-if="modalType == 2">
                    <b-col md="4">
                        <label>Client</label>
                        <model-list-select :list="$store.getters['common/getAllClientList']" id="shipper_id"
                            v-model="updateItem.fk_shipper_id" option-value="clientId" option-text="clientName"
                            placeholder="Select Shipper Name" :style="{
                                borderColor: !updateItem.fk_shipper_id && errorUpdate.fk_shipper_id ? 'red' : '',
                            }" />
                    </b-col>
                    <b-col cols="4">
                        <label for="actual-vessel-name">Actual Vessel Name</label>
                        <b-form-input id="actual-vessel-name" type="text" v-model="updateItem.actual_vessel_name"
                            :style="{
                                borderColor: !updateItem.actual_vessel_name && errorUpdate.actual_vessel_name ? 'red' : '',
                            }" />
                        <span class="error">{{ errorUpdate.actual_vessel_name }}</span>
                    </b-col>

                    <b-col cols="4">
                        <label for="po-number">PO Number <span class='error'>*</span></label>
                        <b-form-input id="po-number" type="text" v-model="updateItem.po_number" :style="{
                            borderColor: !updateItem.po_number && errorUpdate.po_number ? 'red' : '',
                        }" />
                        <span class="error">{{ errorUpdate.po_number }}</span>
                    </b-col>
                    <b-col cols="4">
                        <label for="cargo-estimated-readiness-date">Cargo Estimated Readiness Date</label>
                        <b-form-input id="cargo-estimated-readiness-date" type="date"
                            v-model="updateItem.cargo_estimated_readiness_date" :style="{
                                borderColor: !updateItem.cargo_estimated_readiness_date && errorUpdate.cargo_estimated_readiness_date ? 'red' : '',
                            }" />
                        <span class="error">{{ errorUpdate.cargo_estimated_readiness_date }}</span>
                    </b-col>

                    <b-col cols="4">
                        <label for="estimated-arrival-at-port-date">Estimated Arrival at Port Date</label>
                        <b-form-input id="estimated-arrival-at-port-date" type="date"
                            v-model="updateItem.estimated_arrival_at_port_date" :style="{
                                borderColor: !updateItem.estimated_arrival_at_port_date && errorUpdate.estimated_arrival_at_port_date ? 'red' : '',
                            }" />
                        <span class="error">{{ errorUpdate.estimated_arrival_at_port_date }}</span>
                    </b-col>

                    <b-col cols="4">
                        <label for="tentative-date-sale">Tentative Date Sail</label>
                        <b-form-input id="tentative-date-sale" type="date" v-model="updateItem.tentative_date_sale"
                            :style="{
                                borderColor: !updateItem.tentative_date_sale && errorUpdate.tentative_date_sale ? 'red' : '',
                            }" />
                        <span class="error">{{ errorUpdate.tentative_date_sale }}</span>
                    </b-col>

                    <b-col cols="4">
                        <label for="cargo-arrival-at-port">Cargo Arrival at Port</label>
                        <b-form-input id="cargo-arrival-at-port" type="date" v-model="updateItem.cargo_arrival_at_port"
                            :style="{
                                borderColor: !updateItem.cargo_arrival_at_port && errorUpdate.cargo_arrival_at_port ? 'red' : '',
                            }" />
                        <span class="error">{{ errorUpdate.cargo_arrival_at_port }}</span>
                    </b-col>

                    <b-col cols="4">
                        <label for="estimated-arrival-at-pod-date">Estimated Arrival at POD Date</label>
                        <b-form-input id="estimated-arrival-at-pod-date" type="date"
                            v-model="updateItem.estimated_arrival_at_pod_date" :style="{
                                borderColor: !updateItem.estimated_arrival_at_pod_date && errorUpdate.estimated_arrival_at_pod_date ? 'red' : '',
                            }" />
                        <span class="error">{{ errorUpdate.estimated_arrival_at_pod_date }}</span>
                    </b-col>

                    <b-col cols="4">
                        <label for="actual-arrival-at-pod-date">Actual Arrival at POD Date</label>
                        <b-form-input id="actual-arrival-at-pod-date" type="date"
                            v-model="updateItem.actual_arrival_at_pod_date" :style="{
                                borderColor: !updateItem.actual_arrival_at_pod_date && errorUpdate.actual_arrival_at_pod_date ? 'red' : '',
                            }" />
                        <span class="error">{{ errorUpdate.actual_arrival_at_pod_date }}</span>
                    </b-col>

                    <b-col cols="4">
                        <label for="actual-arrival-at-fpod-date">Actual Arrival at FPOD Date</label>
                        <b-form-input id="actual-arrival-at-fpod-date" type="date"
                            v-model="updateItem.actual_arrival_at_fpod_date" :style="{
                                borderColor: !updateItem.actual_arrival_at_fpod_date && errorUpdate.actual_arrival_at_fpod_date ? 'red' : '',
                            }" />
                        <span class="error">{{ errorUpdate.actual_arrival_at_fpod_date }}</span>
                    </b-col>
                    <b-col cols="12">
                        <label for="remarks">Remarks</label>
                        <b-textarea rows="3" id="remarks" type="text" v-model="updateItem.remarks" :style="{
                            borderColor: !updateItem.remarks && errorUpdate.remarks ? 'red' : '',
                        }" />
                        <span class="error">{{ errorUpdate.remarks }}</span>
                    </b-col>

                </b-row>
                <b-row class="justify-content-end">
                    <b-button variant="primary" style="font-size: 0.675rem" @click="updateAgentCms">Update</b-button>
                    <b-button variant="secondary" style="font-size: 0.675rem" @click="closeModal"
                        class="ml-2">Cancel</b-button>
                </b-row>
            </b-modal>
        </b-card>
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE_DOC } from "../../helper/constant.js";
import CommonService from "../../services/CommonService.js";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import ContaierWebLogSummary from "../common/moduleBasedContaierWebLogSummary.vue";
import CustomLoader from "../common/customLoader.vue";
import NodeLockPannelService from "../../services/NodeLockPannelService";

export default {
    beforeMount() {
        this.$store.dispatch(
            "common/setAllClientList",
            JSON.stringify({
                itemCode: "ClientList"
            })
        );
        this.lastVisitPage = this.$sessionsStorage.get("lastVisitPage");
        const loginId = this.$sessionsStorage.get("loginId");
        if (loginId) {
            this.$store.dispatch("setCurrentRoute", this.$route.path);
            this.getAgentCMSList("Normal", "0", "0", "1", "1");
        } else {
            this.$router.push({ path: "/Login/" });
        }
    },

    data() {
        return {
            updateItem: {
                fclConsoMultipleClientId: "",
                isConsolidation:1,
                JobNo: "",
                preq_cm_id: "",
                fk_client_id: "",
                fk_all_module_id: "",
                fk_consolidation_id: "",
                fk_fcl_exp_id: "",
                cargo_estimated_readiness_date: "",
                estimated_arrival_at_port_date: "",
                tentative_date_sale: "",
                cargo_arrival_at_port: "",
                estimated_arrival_at_pod_date: "",
                actual_arrival_at_pod_date: "",
                actual_arrival_at_fpod_date: "",
                actual_vessel_name: "",
                fk_shipper_id:"",
                po_number: "",
                remarks: "",
            },
            UpdateError: [
                // "Please Enter Cargo Estimated Readiness Date",
                // "Please Enter Estimated Arrival at Port Date",
                // "Please Enter Tentative Date Sail",
                // "Please Enter Cargo Arrival at Port",
                // "Please Enter Estimated Arrival at POD Date",
                // "Please Enter Actual Arrival at POD Date",
                // "Please Enter Actual Arrival at FPOD Date",
                // "Please Enter Actual Vessel Name",
                // "Please Select Shipper Name",
                "Please Enter PO Number",
            ],
            errorUpdate: {
                // cargo_estimated_readiness_date: "",
                // estimated_arrival_at_port_date: "",
                // tentative_date_sale: "",
                // cargo_arrival_at_port: "",
                // estimated_arrival_at_pod_date: "",
                // actual_arrival_at_pod_date: "",
                // actual_arrival_at_fpod_date: "",
                // actual_vessel_name: "",
                // fk_shipper_id: "",
                po_number: "",
            },
            columnLogMain: [{
                key: "SN",
                mainkey: "SN",
                label: "SN.",
                sortable: true,
                sortDirection: "ASC",
                table: "HJ.",
            },
            {
                key: "field_changed",
                mainkey: "field_changed",
                label: "Column Name",
                sortable: true,
                sortDirection: "ASC",
                table: "HJ.",
            },
            {
                key: "old_value",
                mainkey: "old_value",
                label: "Old Value",
                sortable: true,
                sortDirection: "ASC",
                table: "HJ.",
            },
            {
                key: "new_value",
                mainkey: "new_value",
                label: "New Value",
                sortable: true,
                sortDirection: "ASC",
                table: "HJ.",
            },
            {
                key: "remarks",
                mainkey: "remarks",
                label: "Remarks",
                sortable: true,
                sortDirection: "ASC",
                table: "HJ.",
            }],
            LogList: [],
            isLoading: false,
            docURL: URL_BASE_DOC,
            ExcelBtnName: "Export As Excel",
            Filter: { userFilter: this.$sessionsStorage.get("userId") },
            filter: "",
            JOBList: [],
            generateExcel: 0,
            modalType: 2,
            columnMain: [
                {
                    key: "SN",
                    mainkey: "SN",
                    label: "SN.",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "HJ.",
                },
                {
                    key: "mainLocation",
                    mainkey: "mainLocation",
                    label: "Branch",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "A.",
                },
                {
                    key: "bookingNo",
                    mainkey: "bookingNo",
                    label: "Booking No",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "B.",
                },
                {
                    key: "JobNo",
                    lmainkey: "JobNo",
                    label: "JOB Details",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "C.",
                },
                {
                    key: "clientName",
                    mainkey: "clientName",
                    label: "Client",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "D.",
                },
                {
                    key: "shippingLine",
                    lmainkey: "shippingLine",
                    label: "Sline",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "E.",
                },
                {
                    key: "containerNumbers",
                    mainkey: "containerNumbers",
                    label: "Containers",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "F.",
                },
                {
                    key: "POR",
                    mainkey: "POR",
                    label: "POR - POL - POD",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "F.",
                },
                {
                    key: "MultipleContainerType",
                    mainkey: "MultipleContainerType",
                    label: "Container Type",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "J.",
                },
                {
                    key: "agent",
                    mainkey: "agent",
                    label: "Agent",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "K.",
                },
                {
                    key: "agentColoader",
                    mainkey: "agentColoader",
                    label: "Coloder",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "L.",
                },

                {
                    key: "SOB",
                    mainkey: "SOB",
                    label: "SOB",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "N.",
                },

                {
                    key: "HBL",
                    mainkey: "HBL",
                    label: "HBL",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "N.",
                },

                {
                    key: "MBL",
                    mainkey: "MBL",
                    label: "MBL",
                    sortable: true,
                    sortDirection: "ASC",
                    table: "N.",
                },

            ],
            paginationItem: {
                currentPage: 1,
                totalRows: 0,
                perPage: 50,
                pageOptions: [5, 10, 15],
            },
            validate: true,
        };
    },

    components: {
        ContainerSummary,
        JobWisePaymentsDetails,
        ContaierWebLogSummary,
        ModelListSelect,
        CustomLoader,
    },

    methods: {
        validateUpdateFunc() {
            let validate_new = true;
            Object.keys(this.errorUpdate).map((x, index) => {
                if (this.updateItem[x] == "" || this.updateItem[x] == null || this.updateItem[x] == undefined) {
                    this.errorUpdate[x] = this.UpdateError[index];
                    validate_new = false;
                }
            });
            if (validate_new != true) {
                this.validate = false;
            } else {
                this.validate = true;
            }
        },
        async updateAgentCms() {
            this.validateUpdateFunc();
            console.log('this.validate=>', this.validate)
            console.log('this.errorUpdate=>', this.errorUpdate)
            if (this.validate != false) {

                await NodeLockPannelService.upsertAgentCMSDash(this.updateItem)
                    .then((response) => {
                        const { data, status, statusText } = response;
                        // console.log("data PS=>", data);

                        if (status == 200 && data.status == true) {
                            this.getAgentCMSList("Normal", "0", "0", "1", "1");
                        }
                        this.isLoading = false;
                    })
                    .catch((error) => {
                        console.log("Catch on updateAgentCms Error: ", error);
                    });
                this.closeModal();
            }
        },
        closeModal() {
            this.$refs.UpdateCBModal.hide();
        },
        openModal(item, modalType) {
            this.modalType = modalType;
            this.updateItem = item;
            this.LogList = item.preq_client_log;
            this.$refs.UpdateCBModal.show();
        },
        goBack() {
            window.history.go(-1);
        },

        getReports(id, btnName) {
            this.isLoading = true;
            this.generateExcel = "1";
            this.ExcelBtnName = "Downloading Please Wait .....";
            this.getAgentCMSList("Excell", "0", "0", "1", "1");
        },
        getAgentCMSList(type, filterId, CURRENT, SEARCH, pageNumber) {
            this.isLoading = type === "Normal";
            const payload = {
                type,
                DCfilterId: filterId,
                searchVal: this.filter,
                fromSearch: SEARCH,
                currentPage: CURRENT,
                perPage: this.paginationItem.perPage,
                Filter: this.Filter,
                generateExcel:this.generateExcel,
                isAllNo:1,
            };
            const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
            NodeLockPannelService.getAgentCMSConDashList(payload, config)
                .then((response) => {
                    const { data, status, statusText } = response;
                    console.log("data PS=>", data);
                    if (status == 200 && data) {
                        if (this.generateExcel == "1") {
                            // Handle file download
                            const blob = new Blob([data], {
                                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            });
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement("a");
                            link.href = url;
                            link.setAttribute("download", "get-Agent-CMS-panel-report.xlsx"); // Specify the file name
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);

                            this.ExcelBtnName = "Export As Excel";
                            this.generateExcel = "0";
                            this.getAgentCMSList("Normal", "0", "0", "1", "1");
                        } else {
                            if (data.data.length > 0) {
                                this.totalData = data.pagination.totalPaymentList;
                                this.JOBList = data.data;
                                this.paginationItem = {
                                    currentPage: data.pagination.currentPage,
                                    totalRows: data.pagination.totalPaymentList,
                                    perPage: data.pagination.pageSize,
                                }
                            }
                        }
                    }
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log("Catch on getContList Error: ", error);
                });
        },

        filterClear() {
            this.Filter = { userFilter: "" };
            this.getAgentCMSList("Normal", "0", "0", "1", "1");
        },

        debounceSearch() {
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                this.getAgentCMSList("Normal", "0", "0", "1", "1");
            }, 1000);
        },
        onFiltered(filtered) {
            this.paginationItem.totalRows = filtered.length;
            this.paginationItem.currentPage = 1;
        },
    },
};
</script>

<style>
.table-background thead {
    background-color: #a9e4ce;
    border: 2px solid lightgrey;
    position: sticky;
    top: 0;
    font-size: 11px;
}

.my-custom-scrollbar {
    height: 550px;
    overflow: auto;
}

.table-wrapper-scroll-y {
    display: block;
}

.status-alerts {
    font-size: 18px;
    flex-direction: column;
}

.alert {
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 5px;
    color: #fff;
}

.alert-danger-text {
    color: #d9534f;
}

.alert-info-text {
    color: #2a6fde;
}

@keyframes blink {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0;
    }
}

.blink {
    animation: blink 1s infinite;
    font-weight: 800;
    color: red;
}
</style>


// WEBPACK FOOTER //
// agentCmsConsoleDash.vue?5447de68